import { createRemoteJWKSet, jwtVerify } from 'jose';

const JWKS_URL = 'https://bet99.com/g/nextapi/jwks.json';

const jwks = createRemoteJWKSet(new URL(JWKS_URL));

export interface JWTPayload {
  sub_id: {
    uid: string;
    lpid: string;
    rpid: string;
  };
  nbf: number;
  iat: number;
  exp: number;
}

export function computeSsoUserId(payload: JWTPayload): string {
  const ssoUserId = `${payload.sub_id.uid}_${payload.sub_id.lpid}`;
  console.log('[JWT] Computing ssoUserId:', {
    uid: payload.sub_id.uid,
    lpid: payload.sub_id.lpid,
    ssoUserId,
  });

  return ssoUserId;
}

export async function verifyBet99Token(token: string): Promise<JWTPayload | null> {
  // Only verify with JWKS if explicitly enabled
  if (import.meta.env.VITE_ENABLE_SSO_JWKS_VERIFICATION === 'true') {
    try {
      console.log('[JWT] Verifying token with JWKS...');

      const { payload } = await jwtVerify(token, jwks, {
        algorithms: ['RS256'],
      });

      console.log('[JWT] Token verified successfully:', payload);

      // The jose library's JWTPayload type is compatible but not identical
      return payload as JWTPayload;
    } catch (error) {
      console.error('[JWT] Token verification failed:', error);

      return null;
    }
  }

  console.log(
    '[JWT] JWKS verification disabled (VITE_ENABLE_SSO_JWKS_VERIFICATION not set to true)'
  );
  // Just decode without verification when disabled
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error('Invalid JWT format');
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    const payload = JSON.parse(jsonPayload) as JWTPayload;
    console.log('[JWT] Token decoded (without verification):', payload);

    return payload;
  } catch (error) {
    console.error('[JWT] Token decode failed:', error);

    return null;
  }
}
